import {toSnakeCase, toCamelCase} from '@/helpers/string.js'

//Lookup dotted path in an object
export function get(obj, path, defaultValue = undefined) {

  //Empty path, return object
  if (!path) {
    return obj
  }

  //Split path in object keys to traverse
  const keys = path.split('.')
  for (let i = 0; i < keys.length && obj !== undefined; i++) {
    const key = keys[i]
    obj = (obj !== null) ? obj[key] : undefined
  }

  //Return default value if undefined
  if (obj === undefined) {
    return defaultValue
  }

  //Return reference
  return obj
}

//Set dotted path value in an object
export function set(obj, path, value) {

  //Empty path
  if (!path) {
    return
  }

  //Split path in object keys to traverse
  const keys = path.split('.')
  for (let i = 0; i < (keys.length - 1); i++) {
    const key = keys[i]
    if (!obj[key]) {
      obj[key] = {}
    }
    obj = obj[key]
  }

  //Get last key
  const prop = keys[keys.length - 1]
  obj[prop] = value
}

//Simple object check
export function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

//Create form data from object
export function createFormData(obj) {
  if (obj instanceof FormData) {
    return obj
  }
  const formData = new FormData()
  for (const key in obj) {
    formData.append(key, obj[key])
  }
  return formData
}

//Convert form data keys
export function convertFormDataKeys(form, fn) {
  const clone = new FormData()
  for (const [key, value] of form.entries()) {
    const newKey = fn(key)
    clone.append(newKey, value)
  }
  return clone
}

//Convert object keys recursively
export function convertKeys(obj, fn, ignore) {

  //No conversion needed
  if (typeof obj !== 'object' || obj === null || obj instanceof File) {
    return obj
  }

  //Form data given, use special helper
  if (obj instanceof FormData) {
    return convertFormDataKeys(obj, fn)
  }

  //Array given
  if (Array.isArray(obj)) {
    return obj.map(item => convertKeys(item, fn, ignore))
  }

  //Create new object and convert keys
  const clone = {}
  for (const key in obj) {
    const shouldIgnore = Array.isArray(ignore) && ignore.includes(key)
    const newKey = shouldIgnore ? key : fn(key)
    clone[newKey] = convertKeys(obj[key], fn, ignore)
  }

  //Return clone
  return clone
}

//Convert object keys to snake case
export function convertKeysToSnakeCase(obj, ignore) {
  return convertKeys(obj, toSnakeCase, ignore)
}

//Convert object keys to camel case
export function convertKeysToCamelCase(obj, ignore) {
  return convertKeys(obj, toCamelCase, ignore)
}
